import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import 'react-international-phone/style.css';

import { store } from 'lib.store/src';
import { isMatchExpress } from 'lib.shared/src/brand';

import App from './App';
import { installChunkErrorReload } from './utils/chunkReload';
// the app's agent-widget set (meta.kind → component) — see AgentWidgets
import './components/agent-widgets/register';
import './index.scss';

// recover from stale lazy chunks after a deploy (white screen) by reloading once
installChunkErrorReload();

// Match.Express is served by the same build from its own domain — swap the tab branding
if (isMatchExpress()) {
  document.title = 'Match Express';
  const favicon = document.getElementById('dynamic-favicon') as HTMLLinkElement | null;
  if (favicon) {
    favicon.href = '/match.svg';
  }
}

// Use a different favicon in non-production environments so dev is easy to spot
if (import.meta.env.VITE_ENV !== 'production') {
  const favicon = document.getElementById('dynamic-favicon') as HTMLLinkElement | null;
  if (favicon) {
    favicon.href = '/boost-dev.svg';
  }
}

const sentryKey = import.meta.env.VITE_API_SENTRY_KEY as string;

Sentry.init({
  dsn: `https://${sentryKey}.ingest.de.sentry.io/4507582448140368`,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});

// Lazy-load Sentry Session Replay (~300 KB) — loaded asynchronously after page init
Sentry.lazyLoadIntegration('replayIntegration').then((replay) => {
  Sentry.addIntegration(replay());
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
